import { getPrefixedStyleKey } from '@bydesign-ui/hooks';
var transitionKeys = getPrefixedStyleKey('transition');
var transitionRegExp = new RegExp("\n(\\S{1,})\\s{1,}(\\d{1,}(?:.\\d*)?[^\\s,]*)\\s{1,}([^\\s(]{1,}(?:\\([^)]*\\))?)\\s{1,}(\\d{1,}(?:.\\d*)?[^\\s,]*)\n".trim());
var animationKeys = getPrefixedStyleKey('animation');
var animationRegExp = new RegExp("\n(\\d{1,}(?:.\\d*)?[^\\s,]*)\\s{1,}([^\\s(]{1,}(?:\\([^)]*\\))?)\\s{1,}(\\d{1,}(?:.\\d*)?[^\\s,]*)\\s{1,}(\\S{1,})\\s{1,}(\\S{1,})\\s{1,}(\\S{1,})\\s{1,}(\\S{1,})\\s{1,}([^\\s,]{1,})\n".trim());

function matchTransitions(value) {
  var matched = value.match(transitionRegExp);

  if (!matched || matched.length < 5) {
    return null;
  }

  var transitionValue = {
    property: matched[1],
    duration: parseFloat(matched[2]) || 0,
    timingFunction: matched[3],
    delay: parseFloat(matched[4]) || 0
  };
  var nextIndex = (matched.index || 0) + matched[0].length;
  return [transitionValue, nextIndex];
}

function matchAnimations(value) {
  var matched = value.match(animationRegExp);

  if (!matched || matched.length < 9) {
    return null;
  }

  var animationValue = {
    duration: parseFloat(matched[1]) || 0,
    timingFunction: matched[2],
    delay: parseFloat(matched[3]) || 0,
    iterationCount: parseFloat(matched[4]) || Infinity,
    direction: matched[5],
    fillMode: matched[6],
    playState: matched[7],
    keyframes: matched[8]
  };
  var nextIndex = (matched.index || 0) + matched[0].length;
  return [animationValue, nextIndex];
}

export function getTransitionValues(element) {
  return transitionKeys.reduce(function (prev, key) {
    var rawValue = getComputedStyle(element)[key].trim();

    for (var searchIndex = 0; searchIndex < rawValue.length;) {
      var matched = matchTransitions(rawValue.slice(searchIndex));

      if (!matched) {
        break;
      }

      prev.push(matched[0]);
      searchIndex = matched[1];
    }

    return prev;
  }, []);
}
export function getAnimationValues(element) {
  return animationKeys.reduce(function (prev, key) {
    var rawValue = getComputedStyle(element)[key].trim();

    for (var searchIndex = 0; searchIndex < rawValue.length;) {
      var matched = matchAnimations(rawValue.slice(searchIndex));

      if (!matched) {
        break;
      }

      searchIndex = matched[1];
      prev.push(matched[0]);
    }

    return prev;
  }, []);
}